"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_intl_1 = require("react-intl");
const RelativeTime_1 = require("../Components/RelativeTime");
const useIntlMne = () => {
    const { formatDate, formatTime, formatRelativeTime, ...restIntl } = (0, react_intl_1.useIntl)();
    const { defaultFormats, formats } = restIntl;
    return {
        formatDate: (value, opts) => formatDate(value, {
            ...(formats.date || defaultFormats.date.default),
            ...opts,
        }),
        formatDateTime: (value, opts) => formatDate(value, {
            ...(formats.date || defaultFormats.date.dateTime),
            ...opts,
        }),
        formatDateTimeSecond: (value, opts) => formatDate(value, {
            ...(formats.date || defaultFormats.date.dateTimeSecond),
            ...opts,
        }),
        formatTime: (value, opts) => formatTime(value, {
            ...(formats.time || defaultFormats.time.justTime),
            ...opts,
        }),
        formatRelativeTime: (value, unit, opts) => {
            const { value: calculatedValue, unit: calculatedUnit } = (0, RelativeTime_1.valueAndUnit)({ value, unit }, opts.now || new Date());
            return formatRelativeTime(calculatedValue, calculatedUnit, {
                numeric: "auto",
                ...opts,
            });
        },
        ...restIntl,
    };
};
exports.default = useIntlMne;
